// Republic Atlas - Candidate Service

import api from './api';
import type { Candidate, ApiResponse } from '@/types';

export interface CandidateFilters {
  officeId?: string;
  party?: string;
  isIncumbent?: boolean;
  page?: number;
  pageSize?: number;
}

export const candidateService = {
  /**
   * Get all candidates with optional filters
   */
  async getCandidates(filters?: CandidateFilters): Promise<ApiResponse<Candidate[]>> {
    const params = new URLSearchParams();
    if (filters?.officeId) params.append('office_id', filters.officeId);
    if (filters?.party) params.append('party', filters.party);
    if (filters?.isIncumbent !== undefined) params.append('is_incumbent', filters.isIncumbent.toString());
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.pageSize) params.append('page_size', filters.pageSize.toString());

    const response = await api.get<ApiResponse<Candidate[]>>(`/candidates?${params}`);
    return response.data;
  },

  /**
   * Get a single candidate by ID
   */
  async getCandidate(id: string): Promise<Candidate> {
    const response = await api.get<Candidate>(`/candidates/${id}`);
    return response.data;
  },

  /**
   * Get candidates for a specific office
   */
  async getCandidatesByOffice(officeId: string): Promise<Candidate[]> {
    const response = await api.get<ApiResponse<Candidate[]>>(
      `/offices/${officeId}/candidates`
    );
    return response.data.data;
  },

  /**
   * Search candidates by name
   */
  async searchCandidates(query: string): Promise<Candidate[]> {
    const response = await api.get<ApiResponse<Candidate[]>>(
      `/candidates/search?q=${encodeURIComponent(query)}`
    );
    return response.data.data;
  },
};

export default candidateService;

